/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoIntolleranzaDTO
 */
export interface AssistitoIntolleranzaDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoIntolleranzaDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoIntolleranzaDTO interface.
 */
export function instanceOfAssistitoIntolleranzaDTO(value: object): value is AssistitoIntolleranzaDTO {
    return true;
}

export function AssistitoIntolleranzaDTOFromJSON(json: any): AssistitoIntolleranzaDTO {
    return AssistitoIntolleranzaDTOFromJSONTyped(json, false);
}

export function AssistitoIntolleranzaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoIntolleranzaDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoIntolleranzaDTOToJSON(value?: AssistitoIntolleranzaDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

